import { Button, Grid, IconButton, Typography } from "@mui/material";
import { useMutation, useQuery } from "@tanstack/react-query";
import ConfirmDeleteModal from "components/ConfirmDeleteModal";
import GKClientDataGrid from "components/GKClientDataGrid";
import DashboardLayout from "layouts/DashboardLayout/DashboardLayout";
import { useState } from "react";
import { MdDelete } from "react-icons/md";
import { RiEdit2Fill } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import axiosInstance from "utils/axiosInstance";
import { QueryKeys } from "utils/queryKey";
import CreateBrokerModal from "./CreateBrokerModal";

const BrokerMaster = () => {
  const [openBrokerModal, setOpenBrokerModal] = useState(false);
  const navigate = useNavigate();

  const [brokerData, setBrokerData] = useState({});

  const [confirmationModal, setConfirmationModal] = useState(false);

  const [brokerMasterId, setBrokerMasterId] = useState(0);

  const { data: advisorList, refetch } = useQuery({
    queryKey: [QueryKeys.BROKER_MASTER_LIST],
    queryFn: () => axiosInstance.get("/broker/"),
    onError: () => {},
  });

  const { mutate: handleDeleteBroker } = useMutation({
    mutationKey: ["DELETE_BROKER"],
    mutationFn: () => axiosInstance.delete(`/broker/${brokerMasterId}/delete/`),
    onSuccess: () => {
      refetch();
    },
    onError: () => {},
  });

  const brokerColumns = [
    {
      headerName: "Name",
      field: "name",
      flex: 1,
      disableColumnMenu: true,
      minWidth: 150,
    },
    {
      headerName: "Status",
      field: "status",
      flex: 1,
      disableColumnMenu: true,
      minWidth: 150,
    },
    {
      headerName: "Integration Status",
      field: "integrationStatus",
      flex: 1,
      disableColumnMenu: true,
      minWidth: 150,
    },
    {
      headerName: "Meta",
      field: "meta",
      flex: 1,
      disableColumnMenu: true,
      minWidth: 150,
      renderCell: (params) => (
        <Typography>
          {params?.row?.meta}
          {/* {JSON.parse(params?.row?.meta.replace(/'/g, '"')).join(", ")} */}
        </Typography>
      ),
    },
    {
      headerName: "Actions",
      disableColumnMenu: true,
      headerAlign: "right",
      align: "right",
      flex: 1,
      minWidth: 80,
      field: "action",
      type: "action",
      renderCell: (item) => (
        <Grid container gap={1} justifyContent={"flex-end"}>
          <IconButton
            color="primary"
            onClick={(event) => {
              event.stopPropagation();
              navigate(`/app/broker-master/${item.id}`);
            }}
          >
            <RiEdit2Fill size={20} />
          </IconButton>
          <IconButton
            color="error"
            onClick={(event) => {
              event.stopPropagation();
              setBrokerMasterId(item?.id);
              setConfirmationModal(true);
            }}
          >
            <MdDelete size={20} />
          </IconButton>
        </Grid>
      ),
    },
  ];

  return (
    <DashboardLayout
      title="Broker Master"
      breadcrumbs={[
        {
          name: "Broker Master",
          path: "/app/broker-master",
        },
      ]}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <GKClientDataGrid
            autoHeight
            // loading={isFetching}
            columns={brokerColumns}
            rows={advisorList?.data?.data || []}
            onRowClick={(row) => {
              setBrokerData(row.row);
              setOpenBrokerModal(true);
            }}
            headerComponent={
              <Grid container item xs={12} gap={1} justifyContent="flex-end">
                <Button
                  sx={{
                    fontSize: "0.7rem",
                    fontFamily: '"Arial", sans-serif',
                    textTransform: "none",
                  }}
                  onClick={() => {
                    setBrokerData({});
                    setOpenBrokerModal(true);
                  }}
                  variant="contained"
                >
                  Create Broker Master
                </Button>
              </Grid>
            }
          />
          {openBrokerModal && (
            <CreateBrokerModal
              open={openBrokerModal}
              setOpen={setOpenBrokerModal}
              refetch={refetch}
              brokerData={brokerData}
            />
          )}
          {confirmationModal && (
            <ConfirmDeleteModal
              open={confirmationModal}
              setOpen={setConfirmationModal}
              onDelete={() => handleDeleteBroker()}
              title={"Broker Master"}
              isDelete
            />
          )}
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};

export default BrokerMaster;
